import { Navigate } from "react-router-dom";
import { Base_Url_Route, Login_Route } from "./handleRoutes/routesVar";
import { Authentication } from "services/api/authentication/authentication";

const RedirectTo = () => {
  const isSignedIn = Authentication.get();
  if (!isSignedIn.accessToken) {
    return <Navigate to={Login_Route} replace />;
  } else return <Navigate to={Base_Url_Route} replace />;
};

export default RedirectTo;
